document.addEventListener("DOMContentLoaded", function () {
  $(document).ready(function () {
    
    setFeeAmount();
    $("#give_back_request_reward_amount").on('input', function () {
      setFeeAmount();
    });
  });
  
  var setFeeAmount = function () {
    // var value = Math.round($("#give_back_request_reward_amount").val() * 0.3 * 100) / 100;
    
    var value = Math.round($("#give_back_request_reward_amount").val() * 0.05 * 100) / 100;
    
    if (value == 0) {
      $("#give_back_request_fee_amount").val(0);
    } else {
      $("#give_back_request_fee_amount").val(2.5 + value);
    }
  }
});
